import 'angular';
import './templates/audio_player.html';
import * as $ from 'jquery';


angular.module("GorillaBoy.directives")
.directive('audioPlayer', ['$rootScope', '$translate', '$log', '$timeout', 'DocumentService', 'MessageManager', 'Features', 'FeatureManagerService', 'BrowserService',
 ($rootScope, $translate, $log, $timeout, DocumentService, MessageManager, Features, FeatureManagerService, BrowserService) => {
    return {
        templateUrl: './directives/templates/audio_player.html',
        scope: {
            documentId: '<',
            versionId: '<',
            showPlayer: '<',
        },
        link: ($scope, $element) => {
            $scope.audio = new Audio();
            $scope.audio.type = "audio/mpeg";
            $scope.isplaying = false;
            $scope.playButtonImg = "images/play.svg";
            $scope.barstyle = {width: "0%"};
            $scope.currentTime = '0:00';
            $scope.totalTime = '0:00';
            $scope.showAudioControl = true;
            $scope.audioRetry = false;

            var expBackOffTimerPromises = [],
                getTranslatedAudioAttempts = {},
                BACKOFF_THRESHOLD = 60 * 1000;        

            $scope.setTime = function($event) {
                // remove listener on audio
                $scope.audio.removeEventListener('timeupdate', timeupdate, true);

                var position = $event.clientX - $event.target.offsetLeft;
				$scope.timelineWidth = $($element).find('.controls__slider')[0].offsetWidth;

                $scope.time = (position / $scope.timelineWidth) * 100;
                $scope.audio.currentTime = ($scope.time * $scope.audio.duration) / 100;

                $scope.barstyle.width = $scope.time + "%";
            };

            $scope.reset = function() {
                $scope.audio.addEventListener('timeupdate', timeupdate);
            };

            $scope.isAudioPlayerVisible = function() {
                return $scope.showPlayer;
            };

            $scope.audio.addEventListener('timeupdate', timeupdate);
            $scope.clickPlayButton = function() {
                if ($scope.audio.src !== "") {
                    togglePlay();
                } else {
                    $scope.showAudioControl = false;
                    translateAudioWithRetry($scope.documentId, $scope.versionId, "mp3");
                }
            };

            $scope.$on('$destroy', function() {
                // Pause the audio when directive get destoryed which means user leaves the page
                $scope.audio.pause();            
            });

            function formatTime(time: number) {
                let minutes:number = Math.floor(time / 60);
                let seconds:number = time % 60;

                let minutesText:string = minutes.toString();
                let secondsText:string = seconds.toString();

                if (minutes < 10) {
                    minutesText = "0" + minutesText;
                }
                if (seconds < 10) {
                    secondsText = "0" + secondsText;
                }

                return minutesText + ':' + secondsText.substring(0, 2);
            }

            function getTotalTime() {
                $scope.totalTime = formatTime($scope.audio.duration);
                $scope.$apply();
            }

            function timeupdate() {
                $scope.currentTime = formatTime($scope.audio.currentTime);
                $scope.barstyle.width = ($scope.audio.currentTime / $scope.audio.duration) * 100 + "%";
                $scope.$apply();
            }

            function pausePlayer() {
                $scope.playButtonImg = "images/play.svg";
                $scope.audio.pause();
                $scope.isplaying = false;
            }

            function playPlayer() {
                $scope.playButtonImg = "images/pause.svg";
                $scope.audio.play(); 
                $scope.isplaying = true;
            }

            function togglePlay() {
                if($scope.isplaying) {
                    pausePlayer();
                } else {
                    playPlayer();
                }
            }

            function translateAudioWithRetry(docId, versionId, outputformat) {
                function updateAttempts(docId) {
                    if (getTranslatedAudioAttempts[docId]) {
                        getTranslatedAudioAttempts[docId]++;
                    } else {
                        getTranslatedAudioAttempts[docId] = 1;
                    }
                }

                /* This function is used to accomplish exponential backoff.
                 * fn -> function that needs to be called after timer milliseconds
                 * param -> param is the parameter that will be passed to the function
                 * timer -> timer milliseconds after which fn is to be called. This needs to be doubled next time fn is called.
                 */

                function exponentialBackOff(docId, versionId, outputformat) {
                    var timeoutVal = 1000 * Math.pow(2, getTranslatedAudioAttempts[docId]);
                    if (timeoutVal > BACKOFF_THRESHOLD) {
                        timeoutVal = BACKOFF_THRESHOLD;
                    }

                    var timerPromise = $timeout(function() {
                        expBackOffTimerPromises = expBackOffTimerPromises.filter(function(item) {
                            return item !== timerPromise;
                        });
                        translateAudioWithRetry(docId, versionId, outputformat);
                    }.bind(null, docId, versionId, outputformat), timeoutVal);
                    expBackOffTimerPromises.push(timerPromise);
                }

                DocumentService.translateAudio(docId, versionId, outputformat)
                .success(function(data) {
                    if (!data.AudioFileUrl) {
                        if (data.TaskStatus === "failed") {
                            $scope.audioRetry = true;
                        }
                        updateAttempts(docId);
                        exponentialBackOff(docId, versionId, outputformat);
                    } else {
                        $scope.audio.src = data.AudioFileUrl;
                        $scope.showAudioControl = true;
                        $scope.audio.addEventListener('loadedmetadata', getTotalTime);
                        $scope.audio.addEventListener('timeupdate', timeupdate);
                        $scope.audio.play();
                        $scope.playButtonImg = "images/pause.svg";
                    }
                })
                .error(function(data) {
                    if (data) {
                        if (data.Message && data.Message.indexOf('ExceedDocumentCharacterLimitException') >= 0) {
                            MessageManager.addErrorMessage($translate.instant('MESSAGES.DOCUMENT_SIZE_EXCEED_LIMIT_FOR_AUDIO_GENERATION'));
                        } else if (data.Message && data.Message.indexOf('RetryTooManyTimesException') >= 0) {
                            MessageManager.addErrorMessage($translate.instant('MESSAGES.AUDIO_GENERATION_RETRY_TOO_MANY_TIME'));
                        } else {
                            MessageManager.addErrorMessage($translate.instant('MESSAGES.AUDIO_GENERATION_FAIL'));
                        }
                    }
                    $scope.showAudioControl = true;
                });
            }
        }
    };
}])



            